import { RootState } from "../../..";

export const selectCompany = (state: RootState) => state.company.data;
export const selectEmployeePendingState = (state: RootState) =>
  state.company.pending;
export const selectTemplateQuestions = (state: RootState) =>
  state.company.templateQuestions;
export const selectOrgChartCount = (state: RootState) =>
  state.company.orgChartCount;
